<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Investment</li></a>
      <a  @click="depositeDashbord"><li>&nbsp;>&nbsp;Bullions</li></a>

      <li>&nbsp;>&nbsp;Gold Bonds</li>
    </ul>
    <h4 class="welcome-text">Gold Bonds</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          v-model="valid"
          lazy-validation
          @submit.prevent
          class="login-form-box register-page"
        >
            <h4>Enter Details</h4>
            <v-row >
              <v-col xs="12" md="6" class="member_relation_box col" v-for="formAttr in formAttributes" :key="formAttr.id">
                <label class="member-label">{{formAttr['label']}}</label>
                <div v-if="formAttr['type'] == 'select' && formAttr['name'] !='nominee'">
                  <v-select
                    ref="form_attrs"
                    :name="formAttr['name']" 
                    :v-model="formAttr['name']"
                    :items="(formAttr['name']=='bond' )? bond : (formAttr['name']=='purity') ? purity_list : (formAttr['name']=='account_owner')? account_owner :(formAttr['name']=='joint_account_owner')? joint_account_owner : ((formAttr['name']=='nominee')) ? nominee :familyMember"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-select>
                </div>
                <div v-else-if="formAttr['type'] == 'select' && formAttr['name'] =='nominee'">

                  <v-combobox
                    :ref="formAttr['name']"
                    :name="formAttr['name']" 
                    v-model="addMoreField"
                    :items="nominee"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                    multiple
                    small-chips
                    solo
                    v-on:input="limiter"
                    deletable-chips
                  ></v-combobox>
                  <a @click="appendField" class="add-newbox">Add New Nominee</a>
                </div>
               <!--  <div v-else-if="formAttr['type'] == 'input' && (formAttr['name'] == 'current_price' || formAttr['name'] ==  'current_value' || formAttr['name'] ==  'face_value' || formAttr['name'] ==  'maturity_date') || formAttr['name'] == 'interest_rate' ">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required', v => /^(0|[1-9]\d*)$/.test(v) || 'Field must be numeric']:[]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    :value="formAttr['name'] == 'current_price' ? current_price : formAttr['name'] ==  'current_value' ? current_price_as_on : formAttr['name'] ==  'face_value' ? face_value :  formAttr['name'] ==  'interest_rate' ? interest_rate : formAttr['name'] ==  'maturity_date' ? maturity_date : '' "
                    readonly
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && (formAttr['name'] != 'current_price' || formAttr['name'] !=  'current_value' || formAttr['name'] !=  'face_value')" class="rupee-icon">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required', v => /^(0|[1-9]\d*)$/.test(v) || 'Field must be numeric']:[]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateCurrentValueAsOnDate($event,formAttr['name'])"
                    ></v-text-field>
                </div> -->
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'amount_invested'" class="rupee-icon">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="[formAttr['is_required'] ==true ? v => !!v || 'Field is required':[],formAttr['is_numeric'] ==true ? v =>  /^\d{0,8}[.]?\d{1,2}$/ .test(v) || 'Field must be numeric':[]]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateCurrentValueAsOnDate($event,formAttr['name'])"
                    :value="formAttr['name'] == 'quantity' ? quantity : formAttr['name'] ==  'amount_invested' ? amount_invested : ''"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'quantity'">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="[formAttr['is_required'] ==true ? v => !!v || 'Field is required':[],formAttr['is_numeric'] ==true ? v => /^\d*\.?\d*$/.test(v) || 'Field must be numeric':[]]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateCurrentValueAsOnDate($event,formAttr['name'])"
                    :value="quantity"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'amount_invested'">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="[formAttr['is_required'] ==true ? v => !!v || 'Field is required':[],formAttr['is_numeric'] ==true ? v => /^\d*\.?\d*$/.test(v) || 'Field must be numeric':[]]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateCurrentValueAsOnDate($event,formAttr['name'])"
                    :value="amount_invested"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && (formAttr['name'] == 'current_price' || formAttr['name'] ==  'current_value' || formAttr['name'] ==  'face_value' || formAttr['name'] ==  'maturity_date') || formAttr['name'] == 'interest_rate'" :class="(formAttr['name'] == 'face_value' || formAttr['name'] == 'maturity_date' || formAttr['name'] == 'interest_rate') ? '':'rupee-icon'">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    :value="formAttr['name'] == 'current_price' ? current_price : formAttr['name'] == 'face_value' ? face_value :formAttr['name'] == 'maturity_date' ? maturity_date : formAttr['name'] == 'interest_rate' ? interest_rate :formAttr['name'] ==  'current_value' ? current_price_as_on : ''"
                    readonly
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="dd MMM, yyyy"
                    :disabledDates="disabledDates"
                  ></Datepicker>
                </div>
              </v-col>
            </v-row>
            <span
              v-bind:class="{'error-messagebox-login': isAddClassServerError}"
              id="server_side_error"
              >{{serverError}}</span
            >
            <v-row class="buttonbox">
              <v-btn class="blue-border-btn" @click="depositeAccounts"> Cancel </v-btn>
              <v-btn
                class="blue-btn"
                @click="submit"
                :disabled="!isFormValid"
              >
                Save
              </v-btn>
            </v-row>
          </v-form>
      </div>
    </div>
  </div>
</template>
<script>

import Datepicker from 'vuejs-datepicker'
import { validationMixin } from 'vuelidate'
import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
import { POST_API, GET_API, GET_SOVEREIGN_GOLD_BONDS_ADD_DATA, SAVE_BULLIONS_DATA, GET_BULLIONS_DATA, GET_GOLD_BOND_DATA } from "../../../store/actions.type";
import { isEmpty } from 'lodash';

export default {
    components: {
      Datepicker,
    },
    mixins: [validationMixin],
    validations: {
      
    },
    data: () => ({
      valid: true,
      submitted: false,
      activePicker: null,
      menu: false,
      isFormValid:false,
      disabledDates: {
        from: new Date()
      },
      serverError:'',
      isAddClassServerError:false,
      formAttributes:'',
      formAttr:'',
      other_form_field:[],
      accountType:[],
      bank:[],
      familyMember:[],
      nominee:[],
      other_nominee:[],
      curr_balance_date: '',
      account_type:'',
      bank_name:'',
      account_owne:'',
      addMoreField:[],
      nomineeMembers:[],
      form_id:'',
      account_owner:[],
      joint_account_owner:[],
      nominee:[],
      removeFieldData:false,
      allow_nominee:1,
      checkFormData:[],
      bullionType:[],
      purity_list:[],
      current_price:'',
      quantity:'',
      current_price_as_on:'',
      bond:[],
      face_value:'',
      amount_invested:'',
      interest_rate: 0,
      maturity_date: '',

    }), 
    created (){
      Fire.$on("loadData", () => {
        this.sovereignGoldAddForm();
      });
    },
    mounted (){
        if (isEmpty(this.$store.getters.getSovereignGoldBondsAddFormData)) {
          this.sovereignGoldAddForm();
        }else {
          this.allow_nominee = this.$store.getters.getSovereignGoldBondsAddFormData.allow_nominee;
          this.form_id = this.$store.getters.getSovereignGoldBondsAddFormData.data.form_id;
          this.formAttributes = this.$store.getters.getSovereignGoldBondsAddFormData.data.form_attributes.fields;
          let masterDataArr = this.$store.getters.getSovereignGoldBondsAddFormData.data.master_data;
          masterDataArr.forEach(element => {
             if (element.GoldBonds) {
               element.GoldBonds.forEach(dataGoldBonds => {
                this.bond.push({'id':dataGoldBonds.id, 'name':dataGoldBonds.name});
              });
            }
           if (element.FamilyMember) {
              element.FamilyMember.forEach(dataFamily => {
                this.nominee.push(dataFamily.name);
                if(dataFamily.id == 0){
                  this.account_owner.push({'id':'0', 'name':dataFamily.name});
                }
                else{
                  this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                }
                this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
              });
          }
        });
      }

    },
    methods: {
      limiter(e) {
        if((e.length + this.other_form_field.length) > 3) {
          swal.fire({
            title: 'Nominee',
            text: "You can add maximum 3 nominees.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
              
            }
          })
        }
      },
      validate () {
        this.$refs.form.validate()
      },
      backButton(){
        this.checkFormData = [];
        var formData = new FormData(this.$refs.form)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          
          if (result.isConfirmed) {
            this.$router.push({ name: 'Investment'}).catch(()=>{})
          }
        }) : this.$router.push({ name: 'Investment'}).catch(()=>{});
      },
      depositeAccounts(){
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          if (result.isConfirmed) {
            this.$router.push({ name: 'SubCategory'}).catch(()=>{})
          }
        }) : this.$router.push({ name: 'SubCategory'}).catch(()=>{});
      },
      appendField(){
        swal.fire({
          input: 'text',
          inputPlaceholder: 'Enter Nominee',
          inputAttributes: {
          autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: `Save`,
          allowOutsideClick: false,
          allowEscapeKey: false
          }).then((result) => {
            if (result.value) {
             let letters = /^[A-Za-z]+$/;
              if(result.value.length > 30){
                 swal.fire({
                  title: 'Nominee',
                  text: "Nominee Name may not be greater than 30 character.",
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#051d42',
                  confirmButtonText: 'OK',
                  }).then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                })
              }else if(result.value.match(letters))
                {
                  
                this.nominee.push(result.value);
                this.addMoreField.push(result.value);
                }
              else
                {
              swal.fire({
              title: 'Nominee',
              text: "Please enter valid name.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
              }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
               
              }
            })
                }
              
            }
             if (result.value == "") {
            swal
              .fire({
                title: "Nominee",
                text: "This field is required.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  e.pop();
                  return;
                }
              });
          }
          })
       
       
        if (this.addMoreField.length >= 3) {
         swal.fire({
            title: 'Nominee',
            text: "You can add maximum 3 nominees.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
              
            }
          })
        }
      }, 
      removeField (lineId) {
        this.other_form_field.splice(lineId, 1);
      },
      setData(key){
       
      }, 
      submit(e) {
         this.checkFormData = [];
         let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        if(this.checkFormData.length > 0){
          this.submitted = true;
        this.$loading(true)
        let jsonObject = []
        let nominee    = []
        let i=0;
        for (const [key, value] of formData.entries()) {
          if(key == 'nominee' && value !=''){
            value.split(",").forEach(nomineeData => {
              nominee.push(nomineeData)
            });
          }
          else if(Number.isInteger(parseInt(key)) == true){
            nominee.push(value)
          }
          else if(key == "account_owner" || key == "bond" ){
            jsonObject.push({"key":key, "values":parseInt(value) })
          }
          else{
            if(key != 'nominee'){
              jsonObject.push({"key":key, "values":value })
            }
          }
          i++;
        }
        let nomineeArr = {"key":"nominee", "values":nominee}
        jsonObject.push(nomineeArr)

        let collected_data = {"collected_data":jsonObject};
        this.$store.dispatch(SAVE_BULLIONS_DATA, {
          data: {
            aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
            form_id:this.form_id,
            account_owner:getFormData.account_owner.value,
            form_detail:JSON.stringify(collected_data),

          },
          api: 'save-bullion-form-detail',
        }).then(() => {
          this.bullionsList();
          this.$loading(false)
          Toast.fire({
            icon: 'success',
            title: 'Gold Bond form saved successfully'
          })
          this.$router.push({ name: "bullions-dashboard", params: { tab: 'tab-4' }}).catch(()=>{});
        }).catch(() => {
            this.$loading(false)
        })
      }else{
        return;
      }
        
      },
      setMasterData:function(attr_type, val){
        this.isFormValid = this.$refs.form.validate()
        if (attr_type == 'account_owner') {
           let masterDataArr = this.$store.getters.getSovereignGoldBondsAddFormData.data.master_data;
           let i = 0;
            this.nominee = [];
            this.joint_account_owner = [];
            masterDataArr['1']['FamilyMember'].forEach(
            familyMember => {
              if (parseInt(val) != parseInt(familyMember['id'])) {
                  this.nominee.push(familyMember.name);
                  this.joint_account_owner.push({'id':familyMember.id, 'name':familyMember.name});
              }
              i++;
            });
        }else if (attr_type == 'bond') {

            this.$store.dispatch(GET_GOLD_BOND_DATA, {
            data: {
              id:val,
              aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
            },
            api: 'get-gold-bond',
            }).then(() => {

              this.current_price = this.$store.getters.getGoldBondData.data.current_price;
              this.face_value = this.$store.getters.getGoldBondData.data.face_value;
              this.maturity_date = this.$store.getters.getGoldBondData.data.maturity_date;
              this.interest_rate = this.$store.getters.getGoldBondData.data.interest_rate;


              this.current_price_as_on = parseFloat(this.current_price.replace(',',"")) * this.quantity;

             this.current_price_as_on = isNaN(this.current_price_as_on) ? 0 : this.current_price_as_on;

            }).catch(() => {

            })
        }else if (attr_type == 'purity') {

           /* this.$store.dispatch(POST_API, {
            data: {
              id:val,
            },
            api: 'get-price-of-purity',
            }).then((response) => {
              this.current_price = '';
              this.current_price = response.data.price;
              this.current_price_as_on = this.current_price * this.quantity;
            }).catch(() => {

            })*/
        }
      },
      appendFieldOnNominee(attr_type, val){
        if(this.removeFieldData){
          this.removeField(attr_type,1);
        }
        else
        {
        this.nominee.push(val);
        this.addMoreField.push(val);
        this.other_form_field.splice(attr_type, 1);
        }
      },
      depositeDashbord(){
        this.checkFormData = [];
         let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
          denyButtonText: `NO`
        }).then(result => {
          
          if (result.isConfirmed) {
            this.$router.push({ name: "deposit-dashboard"}).catch(()=>{})
          }
        }) : this.$router.push({ name: "deposit-dashboard"}).catch(()=>{});
      },
      showMore(){
        return this.removeFieldData = true;
      },

      calculateCurrentValueAsOnDate(val,attr_type){
        this.isFormValid = this.$refs.form.validate()
         if (attr_type == 'quantity') {

          this.quantity = '';
          this.quantity = val;
          this.current_price_as_on = isNaN(this.quantity)? 0: Math.round(parseFloat(this.current_price.replace(',',""))) * this.quantity;

         }

      },

      sovereignGoldAddForm () {
        this.$loading(true)
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$loading(true);
        this.$store
        .dispatch(GET_SOVEREIGN_GOLD_BONDS_ADD_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            form_type: 34,
          },
          api: "get-bullion-form",
        })
        .then(() => {
          this.allow_nominee = this.$store.getters.getSovereignGoldBondsAddFormData.allow_nominee;
          this.form_id = this.$store.getters.getSovereignGoldBondsAddFormData.data.form_id;
          this.formAttributes = this.$store.getters.getSovereignGoldBondsAddFormData.data.form_attributes.fields;
          let masterDataArr = this.$store.getters.getSovereignGoldBondsAddFormData.data.master_data;
          masterDataArr.forEach(element => {
            if (element.GoldBonds) {
               element.GoldBonds.forEach(dataGoldBonds => {
                this.bond.push({'id':dataGoldBonds.id, 'name':dataGoldBonds.name});
              });
            }
            if (element.FamilyMember) {
              element.FamilyMember.forEach(dataFamily => {
                this.nominee.push(dataFamily.name);
                if(dataFamily.id == 0){
                  this.account_owner.push({'id':'0', 'name':dataFamily.name});
                }
                else{
                  this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                }
                this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
              });
            }
          });
          this.$loading(false)
        }).catch(() => {
         this.$loading(false);
       });

      },

      bullionsList(){

        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;

        this.$store
        .dispatch(GET_BULLIONS_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-bullion-form-detail",
        })
        .then(() => {
          Fire.$emit('barsAndCoinsGraphData');
          this.$loading(false);

        }).catch(() => {

         this.$loading(false);

       });

      },

    },
    
};
</script>
